import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CircularProgress from '@mui/material/CircularProgress';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import AsyncSelect from 'react-select/async';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { fetchData, updateData, postData } from '../../../apiService';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Tooltip } from '@material-ui/core';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa'; // Example for FontAwesome Icon
import AsyncCreatableSelect from 'react-select/async-creatable';
import { useLocation } from 'react-router-dom';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Select from 'react-select'; // Import react-select

const SaleReturnEdit = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL  
    const [selectedItems, setSelectedItems] = useState([]);
    const [orderDetails, setOrderDetails] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [formData, setFormData] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const history = useHistory();
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [selectedSalesMan, setSelectedSalesMan] = useState("");
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);
    const [defaultFreightGSTRate, setdefaultFreightGSTRate] = useState(0);
    const [defaultPackingGSTRate, setdefaultPackingGSTRate] = useState(0);
    const location = useLocation();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, userId, token, logout]);

    //Bank
    const [bankOptions, setBankOptions] = useState([]);
    const [selectedBank, setSelectedBank] = useState("");

    const fetchBanks = async () => {
        try {
            const response = await fetchData('PaymentApi', `/Banks/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(method => ({
                    value: method.Id,
                    label: method.Name
                }));
                setBankOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Bank:', error);
        }
    };

    const handleBankChange = (selectedOption) => {
        setSelectedBank(selectedOption);
        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: userId,
            CompanyId: companyId,
            BankId: selectedOption.value,
        }));
    };

    useEffect(() => {
        fetchBanks();
    }, []);

    useEffect(() => {
        fetchData('SaleReturnApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Sale);
                    setSelectedItems(response.response_data.SaleDetails);

                    setSelectedBank({
                        value: response.response_data.Sale.BankId,
                        label: response.response_data.Sale.BankName
                    });
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    useEffect(() => {
        fetchBranchData();
        fetchDropdownSalesManOptions();
        fetchfrightrate();
    }, []);

    const fetchfrightrate = () => {
        fetchData('CompanyApi', `/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {

                setFormData(prevData => ({
                    ...prevData,
                    FreightGSTRate: data[0].FreightGSTRate,
                    PackingGSTRate: data[0].FreightGSTRate,
                }));
                setdefaultFreightGSTRate(data[0].FreightGSTRate);
                setdefaultPackingGSTRate(data[0].FreightGSTRate);
            })
            .catch((error) => {
                console.error('Error fetching options:', error);
            });
    };

    const fetchBranchData = () => {
        fetchData('BranchApi', `/BranchDetails/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {

                setFormData(prevData => ({
                    ...prevData,
                    DispatchFrom: data.CompanyName,
                    DispatchAddress1: data.AddressLine1,
                    DispatchAddress2: data.AddressLine2,
                    DispatchLocation: data.Location,
                    DispatchPincode: data.PinCode,

                    TransporterName: data.TransporterName,
                    TransporterGST: data.GSTNumber,
                }));

            })
            .catch((error) => {
                console.error('Error Dispatch Deatils', error);
            });
    };

    //FOR GET InvoicetypeData  Details FROM API
    const fetchDropdownSalesManOptions = () => {
        fetchData('SaleReturnApi', `/SalesMan/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownSalesManOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Sales Man dropdown options:', error);
            });
    };

    // // Helper function to parse and handle NaN values as 0
    // const parseAndFix = (val) => parseFloat(val) || 0;


    // const calculateItemData = (item, formData) => {
    //     let rate = parseAndFix(item.Rate);
    //     let quantity = parseAndFix(item.Quantity);
    //     let cgstRate = parseAndFix(item.GSTRate) / 2;
    //     let sgstRate = parseAndFix(item.GSTRate) / 2;
    //     let Discper = parseAndFix(item.DiscountPercentage);
    //     let Addidiscamt = ((rate * Discper) / 100).toFixed(2)
    //     let totdiscount = parseFloat(Addidiscamt);
    //     let grate = (rate - totdiscount).toFixed(2);
    //     let amt = (quantity * rate).toFixed(2);
    //     let amount = (quantity * grate).toFixed(2);
    //     let cgstAmount = 0, sgstAmount = 0, igstAmount = 0;

    //     if (formData.InvoiceTypeId === 3) {
    //         igstAmount = ((amount * (cgstRate + sgstRate)) / 100).toFixed(2);
    //     } else {
    //         cgstAmount = ((amount * cgstRate) / 100).toFixed(2);
    //         sgstAmount = ((amount * sgstRate) / 100).toFixed(2);
    //     }

    //     let defaultFreightGST = Math.max(defaultFreightGSTRate, item.GSTRate);
    //     let defaultPackingGST = Math.max(defaultPackingGSTRate, item.GSTRate);
    //     setdefaultFreightGSTRate(defaultFreightGST);
    //     setdefaultPackingGSTRate(defaultPackingGST);

    //     const totalAmount = parseAndFix(amount) + parseAndFix(cgstAmount) + parseAndFix(sgstAmount) + parseAndFix(igstAmount);

    //     return {
    //         ...item,
    //         Amount: amt,
    //         DiscountAmount: parseAndFix(totdiscount * quantity).toFixed(2),
    //         TaxableAmount: amount,
    //         CGSTAmount: cgstAmount,
    //         SGSTAmount: sgstAmount,
    //         IGSTAmount: igstAmount,
    //         TotalAmount: totalAmount.toFixed(2),

    //     };
    // };


    // const totalCalculation = (Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, FreightAmount, PackingAmount, TCSAmount, CashAmount, CardAmount, UPIAmount) => {

    //     let freightGSTRate = parseAndFix(formData.FreightGSTRate);
    //     let packingGSTRate = parseAndFix(formData.PackingGSTRate);
    //     freightGSTRate = Math.max(freightGSTRate, parseAndFix(defaultFreightGSTRate));
    //     packingGSTRate = Math.max(packingGSTRate, parseAndFix(defaultFreightGSTRate));
    //     let freightGSTAmount = ((FreightAmount * freightGSTRate) / 100).toFixed(2);
    //     let packingGSTAmount = ((PackingAmount * packingGSTRate) / 100).toFixed(2);

    //     let netAmount = parseAndFix(TaxableAmount) + parseAndFix(CGSTAmount) + parseAndFix(SGSTAmount) + parseAndFix(IGSTAmount) + parseAndFix(FreightAmount) + parseAndFix(PackingAmount) + parseAndFix(freightGSTAmount) + parseAndFix(packingGSTAmount) + parseAndFix(TCSAmount);
    //     let roundOff = Math.round(netAmount) - netAmount;
    //     let grandTotal = netAmount + roundOff;
    //     let balhamt = parseFloat(grandTotal - (parseAndFix(CashAmount) + parseAndFix(CardAmount) + parseAndFix(UPIAmount)));

    //     setFormData((prev) => ({
    //         ...prev,
    //         TotalQuantity: Quantity,
    //         TotalAmount: Amount.toFixed(2),
    //         TaxableAmount: TaxableAmount.toFixed(2),
    //         CGSTAmount: CGSTAmount.toFixed(2),
    //         SGSTAmount: SGSTAmount.toFixed(2),
    //         IGSTAmount: IGSTAmount.toFixed(2),
    //         RoundOff: roundOff.toFixed(2),
    //         GrandTotal: grandTotal.toFixed(2),
    //         BalanceAmount: balhamt.toFixed(2),
    //         DiscountAmount: DiscountAmount.toFixed(2),
    //         FreightGSTAmount: freightGSTAmount,
    //         PackingGSTAmount: packingGSTAmount,
    //         ModifiedBy: userId,
    //         FreightGSTRate: freightGSTRate,
    //         PackingGSTRate: packingGSTRate,
    //     }));
    // };

    // // Calculation
    // const handleCalculation = (e, index, inputType) => {
    //     let name, value;
    //     if (typeof e === 'object') {
    //         name = e.target.name;
    //         value = e.target.value;
    //     } else {
    //         name = inputType;
    //         value = e;
    //     }

    //     // Assuming selectedItems is a state setter function (e.g., setSelectedItems)
    //     setSelectedItems((prevDetails) => {

    //         const updatedDetails = [...prevDetails];
    //         const currentItem = { ...updatedDetails[index], [name]: value };

    //         // Update the item in the copied array
    //         updatedDetails[index] = currentItem;

    //         const updatedItemData = updatedDetails.map((item) => calculateItemData(item, formData));

    //         const totals = updatedItemData.reduce(
    //             (acc, item) => {
    //                 acc.Quantity += parseAndFix(item.Quantity);
    //                 acc.Amount += parseAndFix(item.Amount);
    //                 acc.DiscountAmount += parseAndFix(item.DiscountAmount);
    //                 acc.TaxableAmount += parseAndFix(item.TaxableAmount);
    //                 acc.CGSTAmount += parseAndFix(item.CGSTAmount);
    //                 acc.SGSTAmount += parseAndFix(item.SGSTAmount);
    //                 acc.IGSTAmount += parseAndFix(item.IGSTAmount);
    //                 acc.TotalAmount += parseAndFix(item.TotalAmount);

    //                 return acc;
    //             },
    //             { Quantity: 0, Amount: 0, DiscountAmount: 0, TaxableAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0 }
    //         );

    //         const FreightAmount = parseAndFix(formData.FreightAmount);
    //         const PackingAmount = parseAndFix(formData.PackingAmount);
    //         const TCSAmount = parseAndFix(formData.TCSAmount);
    //         let CashAmount = parseAndFix(formData.CashAmount) || 0;
    //         let CardAmount = parseAndFix(formData.CardAmount) || 0;
    //         let UPIAmount = parseAndFix(formData.UPIAmount) || 0;

    //         totalCalculation(
    //             totals.Quantity,
    //             totals.Amount,
    //             totals.DiscountAmount,
    //             totals.TaxableAmount,
    //             totals.CGSTAmount,
    //             totals.SGSTAmount,
    //             totals.IGSTAmount,
    //             totals.TotalAmount,
    //             FreightAmount,
    //             PackingAmount,
    //             TCSAmount,
    //             CashAmount,
    //             CardAmount,
    //             UPIAmount,
    //         );

    //         return updatedItemData;
    //     });
    // };

    // const handleChange = (event) => {
    //     const { name, value, type, checked } = event.target;

    //     // Immediate update of the input field
    //     let updatedValue = type === 'checkbox' ? checked : (value === "" ? "0" : value);

    //     // Validation and adjustment for CardAmount, UPIAmount, and CashAmount
    //     if (['CardAmount', 'UPIAmount', 'CashAmount'].includes(name)) {
    //         const grandTotal = parseFloat(formData.GrandTotal || 0);
    //         const otherAmounts = {
    //             CardAmount: parseFloat(formData.CashAmount || 0) + parseFloat(formData.UPIAmount || 0),
    //             UPIAmount: parseFloat(formData.CashAmount || 0) + parseFloat(formData.CardAmount || 0),
    //             CashAmount: parseFloat(formData.CardAmount || 0) + parseFloat(formData.UPIAmount || 0),
    //         };

    //         // Calculate the maximum allowed value for the current field
    //         const maxAllowed = grandTotal - otherAmounts[name];

    //         // Ensure the entered value does not exceed the maxAllowed
    //         updatedValue = Math.min(parseFloat(updatedValue || 0), maxAllowed);
    //     }

    //     setFormData((prevData) => ({
    //         ...prevData,
    //         [name]: updatedValue,
    //     }));

    //     if (['FreightAmount', 'PackingAmount', 'TCSAmount', 'CashAmount', 'CardAmount', 'UPIAmount'].includes(name)) {
    //         // Use the value directly for the calculation to avoid relying on stale state
    //         updateFormDataAndDetails(name, updatedValue);
    //     }
    // };

    // const updateFormDataAndDetails = (key, value) => {
    //     // const fixedValue = parseAndFix(value).toFixed(2);
    //     const fixedValue = parseAndFix(value);

    //     // Update the formData with the new value
    //     setFormData((prevData) => ({
    //         ...prevData,
    //         [key]: fixedValue,
    //         ModifiedBy: userId,
    //     }));

    //     // Use the updated value for calculations
    //     const updatedFormData = {
    //         ...formData,    // current form data
    //         [key]: fixedValue  // the newly updated value
    //     };

    //     // Recalculate invoice details using the latest form data
    //     const updatedItemData = selectedItems.map((item) => calculateItemData(item, updatedFormData));
    //     setSelectedItems(updatedItemData);

    //     // Calculate totals based on the updated invoice details
    //     const totals = calculateTotals(updatedItemData);

    //     // Dynamically get the values from the updated form data
    //     const dynamicValue = (key) => parseAndFix(updatedFormData[key] || 0);

    //     // Fetch the latest values for calculations               
    //     const TCSAmount = dynamicValue('TCSAmount');
    //     const FreightAmount = dynamicValue('FreightAmount');
    //     const PackingAmount = dynamicValue('PackingAmount');
    //     let CashAmount = dynamicValue('CashAmount');
    //     let CardAmount = dynamicValue('CardAmount');
    //     let UPIAmount = dynamicValue('UPIAmount');
    //     // Perform the final total calculation
    //     totalCalculation(
    //         totals.Quantity,
    //         totals.Amount,
    //         totals.DiscountAmount,
    //         totals.TaxableAmount,
    //         totals.CGSTAmount,
    //         totals.SGSTAmount,
    //         totals.IGSTAmount,
    //         totals.TotalAmount,
    //         FreightAmount,
    //         PackingAmount,
    //         TCSAmount,
    //         CashAmount,
    //         CardAmount,
    //         UPIAmount,
    //     );
    // };

    // // Utility function to calculate totals
    // const calculateTotals = (updatedItemData) => {
    //     return updatedItemData.reduce(
    //         (acc, item) => {
    //             acc.Quantity += parseAndFix(item.Quantity);
    //             acc.Amount += parseAndFix(item.Amount);
    //             acc.TaxableAmount += parseAndFix(item.TaxableAmount);
    //             acc.DiscountAmount += parseAndFix(item.DiscountAmount);
    //             acc.CGSTAmount += parseAndFix(item.CGSTAmount);
    //             acc.SGSTAmount += parseAndFix(item.SGSTAmount);
    //             acc.IGSTAmount += parseAndFix(item.IGSTAmount);
    //             acc.TotalAmount += parseAndFix(item.TotalAmount);
    //             return acc;
    //         },
    //         { Quantity: 0, Amount: 0, TaxableAmount: 0, DiscountAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0, CESSAmount: 0 }
    //     );
    // };



      const parseAndFix = (val) => parseFloat(val) || 0;
    

    // FOR Calculation
    const totalCalculation = (Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, FreightAmount, PackingAmount, TCSAmount, CashAmount, CardAmount, UPIAmount) => {

        let freightGSTRate = parseAndFix(formData.FreightGSTRate);
        let packingGSTRate = parseAndFix(formData.PackingGSTRate);
        freightGSTRate = Math.max(freightGSTRate, parseAndFix(defaultFreightGSTRate));
        packingGSTRate = Math.max(packingGSTRate, parseAndFix(defaultFreightGSTRate));

        let freightGSTAmount = ((FreightAmount * freightGSTRate) / 100).toFixed(2);
        let packingGSTAmount = ((PackingAmount * packingGSTRate) / 100).toFixed(2);

        let netAmount = parseAndFix(TaxableAmount) + parseAndFix(CGSTAmount) + parseAndFix(SGSTAmount) + parseAndFix(IGSTAmount) + parseAndFix(FreightAmount) + parseAndFix(PackingAmount) + parseAndFix(freightGSTAmount) + parseAndFix(packingGSTAmount) + parseAndFix(TCSAmount);
        let roundOff = Math.round(netAmount) - netAmount;
        let grandTotal = netAmount + roundOff;
        let balhamt = parseFloat(grandTotal - (parseAndFix(CashAmount) + parseAndFix(CardAmount) + parseAndFix(UPIAmount)));

        setFormData((prev) => ({
            ...prev,
            TotalQuantity: Quantity,
            TotalAmount: Amount.toFixed(2),
            TaxableAmount: TaxableAmount.toFixed(2),
            CGSTAmount: CGSTAmount.toFixed(2),
            SGSTAmount: SGSTAmount.toFixed(2),
            IGSTAmount: IGSTAmount.toFixed(2),
            RoundOff: roundOff.toFixed(2),
            GrandTotal: grandTotal.toFixed(2),
            BalanceAmount: balhamt.toFixed(2),
            DiscountAmount: DiscountAmount.toFixed(2),
            FreightGSTAmount: freightGSTAmount,
            PackingGSTAmount: packingGSTAmount,
            ModifiedBy: userId,
            FreightGSTRate: freightGSTRate,
            PackingGSTRate: packingGSTRate,
        }));
    };


    // Calculation
    const handleCalculation = (e, index, inputType) => {
        let name, value;
        if (typeof e === 'object') {
            name = e.target.name;
            value = e.target.value;
        } else {
            name = inputType;
            value = e;
        }

        // Assuming selectedItems is a state setter function (e.g., setSelectedItems)
        setSelectedItems((prevDetails) => {

            const updatedDetails = [...prevDetails];
            const currentItem = { ...updatedDetails[index], [name]: value };

            // Update the item in the copied array
            updatedDetails[index] = currentItem;

            const updatedItemData = updatedDetails.map((item) => calculateItemData(item, formData));

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                    acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                    acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);

                    return acc;
                },
                { Quantity: 0, Amount: 0, DiscountAmount: 0, TaxableAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0 }
            );

            const FreightAmount = parseAndFix(formData.FreightAmount);
            const PackingAmount = parseAndFix(formData.PackingAmount);
            const TCSAmount = parseAndFix(formData.TCSAmount);
            let CashAmount = parseAndFix(formData.CashAmount) || 0;
            let CardAmount = parseAndFix(formData.CardAmount) || 0;
            let UPIAmount = parseAndFix(formData.UPIAmount) || 0;

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.DiscountAmount,
                totals.TaxableAmount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                FreightAmount,
                PackingAmount,
                TCSAmount,
                CashAmount,
                CardAmount,
                UPIAmount,
            );

            return updatedItemData;
        });
    };

    const calculateItemData = (item, formData) => {

        // Decide which rate to use
        let baseRate = formData.IsWholeSaleRate
            ? parseAndFix(item.WholeSaleRate)   // <-- Wholesale Rate field
            : parseAndFix(item.SaleRate ?? item.Rate); // <-- Fallback to SaleRate or Rate

        let rate = parseAndFix(baseRate);
        let quantity = parseAndFix(item.Quantity);
        let cgstRate = parseAndFix(item.GSTRate) / 2;
        let sgstRate = parseAndFix(item.GSTRate) / 2;
        let Discper = parseAndFix(item.DiscountPercentage);
        let Addidiscamt = ((rate * Discper) / 100).toFixed(2)
        let totdiscount = parseFloat(Addidiscamt);
        let grate = (rate - totdiscount).toFixed(2);
        let amt = (quantity * rate).toFixed(2);

        let salerate = (grate / (1 + (cgstRate + sgstRate) / 100)).toFixed(2);
        let amount = (quantity * salerate).toFixed(2);

        //let amount = (quantity * grate).toFixed(2);
        let cgstAmount = 0, sgstAmount = 0, igstAmount = 0;

        if (formData.InvoiceTypeId === 3 || formData.InvoiceTypeId == 4) {
            igstAmount = ((amount * (cgstRate + sgstRate)) / 100).toFixed(2);
        } else {
            cgstAmount = ((amount * cgstRate) / 100).toFixed(2);
            sgstAmount = ((amount * sgstRate) / 100).toFixed(2);
        }

        let defaultFreightGST = Math.max(defaultFreightGSTRate, item.GSTRate);
        let defaultPackingGST = Math.max(defaultPackingGSTRate, item.GSTRate);
        setdefaultFreightGSTRate(defaultFreightGST);
        setdefaultPackingGSTRate(defaultPackingGST);

        const totalAmount = parseAndFix(amount) + parseAndFix(cgstAmount) + parseAndFix(sgstAmount) + parseAndFix(igstAmount);

        return {
            ...item,
            Amount: amt,
            Rate: rate.toFixed(2),
            DiscountAmount: parseAndFix(totdiscount * quantity).toFixed(2),
            TaxableAmount: amount,
            CGSTAmount: cgstAmount,
            SGSTAmount: sgstAmount,
            IGSTAmount: igstAmount,
            TotalAmount: totalAmount.toFixed(2),

        };
    };

    //handle change
    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        // Immediate update of the input field
        let updatedValue = type === 'checkbox' ? checked : (value === "" ? "0" : value);

        // Validation and adjustment for CardAmount, UPIAmount, and CashAmount
        if (['CardAmount', 'UPIAmount', 'CashAmount'].includes(name)) {
            const grandTotal = parseFloat(formData.GrandTotal || 0);
            const otherAmounts = {
                CardAmount: parseFloat(formData.CashAmount || 0) + parseFloat(formData.UPIAmount || 0),
                UPIAmount: parseFloat(formData.CashAmount || 0) + parseFloat(formData.CardAmount || 0),
                CashAmount: parseFloat(formData.CardAmount || 0) + parseFloat(formData.UPIAmount || 0),
            };

            // Calculate the maximum allowed value for the current field
            const maxAllowed = grandTotal - otherAmounts[name];

            // Ensure the entered value does not exceed the maxAllowed
            updatedValue = Math.min(parseFloat(updatedValue || 0), maxAllowed);
        }

        setFormData((prevData) => ({
            ...prevData,
            [name]: updatedValue,
        }));

        if (['FreightAmount', 'PackingAmount', 'TCSAmount', 'CashAmount', 'CardAmount', 'UPIAmount', 'InvoiceTypeId'].includes(name)) {
            // Use the value directly for the calculation to avoid relying on stale state
            updateFormDataAndDetails(name, updatedValue);
        }
    };

    const updateFormDataAndDetails = (key, value) => {
        // const fixedValue = parseAndFix(value).toFixed(2);
        const fixedValue = parseAndFix(value);

        // Update the formData with the new value
        setFormData((prevData) => ({
            ...prevData,
            [key]: fixedValue,
            ModifiedBy: userId,
        }));

        // Use the updated value for calculations
        const updatedFormData = {
            ...formData,    // current form data
            [key]: fixedValue  // the newly updated value
        };

        // Recalculate invoice details using the latest form data
        const updatedItemData = selectedItems.map((item) => calculateItemData(item, updatedFormData));
        setSelectedItems(updatedItemData);

        // Calculate totals based on the updated invoice details
        const totals = calculateTotals(updatedItemData);

        // Dynamically get the values from the updated form data
        const dynamicValue = (key) => parseAndFix(updatedFormData[key] || 0);

        // Fetch the latest values for calculations               
        const TCSAmount = dynamicValue('TCSAmount');
        const FreightAmount = dynamicValue('FreightAmount');
        const PackingAmount = dynamicValue('PackingAmount');
        let CashAmount = dynamicValue('CashAmount');
        let CardAmount = dynamicValue('CardAmount');
        let UPIAmount = dynamicValue('UPIAmount');
        // Perform the final total calculation
        totalCalculation(
            totals.Quantity,
            totals.Amount,
            totals.DiscountAmount,
            totals.TaxableAmount,
            totals.CGSTAmount,
            totals.SGSTAmount,
            totals.IGSTAmount,
            totals.TotalAmount,
            FreightAmount,
            PackingAmount,
            TCSAmount,
            CashAmount,
            CardAmount,
            UPIAmount,
        );
    };
    // Utility function to calculate totals
    const calculateTotals = (updatedItemData) => {
        return updatedItemData.reduce(
            (acc, item) => {
                acc.Quantity += parseAndFix(item.Quantity);
                acc.Amount += parseAndFix(item.Amount);
                acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                acc.TotalAmount += parseAndFix(item.TotalAmount);
                return acc;
            },
            { Quantity: 0, Amount: 0, TaxableAmount: 0, DiscountAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0, CESSAmount: 0 }
        );
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        setFormData(prevData => ({
            ...prevData,
            CreatedBy: userId,
            BranchId: branchId,
            CompanyId: companyId,
            BankId: selectedBank ? selectedBank.value : null, // Save BankId
        }));


        const CreateData = {
            Sale: formData,
            SaleDetails: selectedItems
        };

        // Validate form data here if needed

        updateData('SaleReturnApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/SaleReturnIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    //search
    const filteredData = selectedItems.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);
    };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const updatedItemList = selectedItems.filter((_, i) => i !== itemToDeleteIndex);
            setSelectedItems(updatedItemList);
            closeConfirmDialog();
        }
    };

    const [itemsOptions, setItemsrOptions] = useState([]);
    const handleItemChange = (newValue) => newValue;
    const fetchItemOptions = async (inputValue = '') => {
        // Early return if input value is empty or too short
        if (!inputValue || inputValue.length <= 1) {
            return [];
        }

        const customerid = formData.MasterId !== null ? formData.MasterId : 0;
        try {
            // Fetch data from the API
            const response = await fetchData('SaleReturnApi', `/Item/${companyId}/${branchId}/${customerid}/${inputValue}`, token);

            // Check if the response code is 1111
            if (response.responseCode === '1111') {
                const data = await response.response_data;
                setItemsrOptions(data);
                // Ensure the response data is an array
                if (Array.isArray(data)) {
                    // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.ItemName1,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching item options:', error);
            return [];
        }
    };

    //// modalData 
    // FOR MODEL DATA (Invoice Details)
    const [selectedItemOption, setSelectedItemOption] = useState(null);

    const [modalData, setModalData] = useState({
        SlNo: '0',
        ItemName1: '',
        ItemId: '',
        Quantity: '',
        Rate: '',
        Amount: '',
        TaxableAmount: '',
        GSTRate: '',
        GSTAmount: '',
        TotalAmount: '',
    });

    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const shouldReload = localStorage.getItem('shouldReload') === 'true';

        if (location.state?.from === '/SaleReturnIndex' && shouldReload) {
            localStorage.removeItem('shouldReload'); // Clear the flag after use
            window.location.reload();
        }
    }, [location]);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen((prev) => !prev);
    };


    return (
        <div
            style={{
                fontFamily: "Segoe UI, sans-serif",
                fontSize: "12px",
                width: "100%",
                padding: "5px",
                marginTop: '10px'
            }}
        >
            {/* Header */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #ccc",
                    paddingBottom: "6px",
                    marginBottom: "12px"
                }}
            >
                <h6 className="uppercase tracking-wide font-serif text-black mt-2">
                    Sale Return Edit
                </h6>

                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "350px 130px 130px 100px", // 4 columns
                        gap: "10px",
                        marginBottom: "12px",
                        alignItems: "end"
                    }}
                >
                    {/* Supplier */}
                    <div>
                        <label style={{ fontSize: "11px", fontWeight: "600" }}>
                            Customer
                            <span style={{ color: "black", marginLeft: "8px" }}>
                                Invoice : {formData.InvoiceTypeName}
                            </span>
                        </label>
                        <input
                            type="text"
                            name="CustomerName"
                            value={formData.CustomerName}
                            onChange={handleChange}
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "12px",
                                height: "28px",
                                width: "100%",
                                padding: "0 6px"
                            }}
                            readOnly
                        />
                    </div>

                    {/* Purchased Bill No */}
                    <div>
                        <label style={{ fontSize: "11px", fontWeight: "600" }}>
                            Sale Bill No
                        </label>
                        <input
                            type="text"
                            name="SaleBillNumber"
                            value={formData.SaleBillNumber}
                            onChange={handleChange}
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "12px",
                                height: "28px",
                                width: "100%",
                                padding: "0 6px"
                            }}
                            readOnly
                        />
                    </div>

                    {/* Purchased Bill Date */}
                    <div>
                        <label style={{ fontSize: "11px", fontWeight: "600" }}>
                            Sale Bill Date
                        </label>
                        <input
                            type="date"
                            name="SaleBillDate"
                            value={formatDateForInput(formData.SaleBillDate)}
                            onChange={handleChange}
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "12px",
                                height: "28px",
                                width: "100%",
                                padding: "0 6px"
                            }}
                            readOnly
                        />
                    </div>

                </div>

                <div className="flex items-center gap-3 mt-2 md:mt-0" style={{ flexShrink: 0 }}>
                    {/* Save Button */}
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={isLoading}
                        style={{
                            height: "25px",
                            minWidth: "80px",
                            borderRadius: "6px",
                            backgroundColor: "#1E3A8A", // deep ERP-blue
                            color: "#FFFFFF",
                            fontWeight: 600,
                            fontSize: "13px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            textTransform: "none",
                            transition: "background-color 0.2s, box-shadow 0.2s",
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#3B82F6")}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#1E3A8A")}
                    >
                        {isLoading ? <CircularProgress size={20} color="inherit" /> : "Update"}
                    </Button>

                    {/* Back To List Button */}
                    <Button
                        variant="contained"
                        component={Link}
                        to="/SaleReturnIndex"
                        className="linkcolor"
                        onClick={() => localStorage.setItem("shouldReload", "true")}
                        style={{
                            height: "25px",
                            minWidth: "90px",
                            borderRadius: "6px",
                            backgroundColor: "#F3F4F6", // light gray ERP style
                            color: "#1E3A8A",
                            fontWeight: 600,
                            fontSize: "13px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            textTransform: "none",
                            transition: "background-color 0.2s, box-shadow 0.2s",
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#E5E7EB")}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#F3F4F6")}
                    >
                        Back To List
                    </Button>
                </div>
            </div>

            {/* Top Section - Supplier & Bill */}
            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            <div
                style={{
                    display: "grid",
                    //gridTemplateColumns: "130px repeat(10, 1fr)",
                    // gridTemplateColumns: "repeat(11, 1fr)",
                    //gridTemplateColumns: "95px 105px 140px 140px 140px 130px 130px 130px 130px 130px 130px",
                    gridTemplateColumns: "95px 105px 140px 140px repeat(7, 1fr)",
                    gap: "10px",
                    marginBottom: "12px",
                    alignItems: "end" // ✅ aligns all inputs properly
                }}
            >
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}> Sale RTN Date</label>
                    <input
                        type="date"
                        name="BillDate"
                        value={formatDateForInput(formData.BillDate)}
                        onChange={handleChange}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px"
                        }}
                    />
                </div>
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>
                        Sale RTN Number
                    </label>
                    <input
                        type="text"
                        name="BillNumber"
                        value={`${formData.BillPrefix || ''}/${formData.BillNumber || ''}/${formData.FinYear || ''}`}
                        onChange={handleChange}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px"
                        }}
                        readOnly
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Freight
                        <span style={{ color: 'darkmagenta', marginLeft: '3px' }}>({formData.FreightGSTRate}%)</span>
                        <span style={{ color: 'red', marginLeft: '3px' }}>{formData.FreightGSTAmount}</span>
                    </label>
                    <input
                        type="number"
                        name="FreightAmount"
                        value={formData.FreightAmount}
                        onChange={handleChange}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Packing
                        <span style={{ color: 'darkmagenta', marginLeft: '3px' }}> ({formData.PackingGSTRate}%)</span>
                        <span style={{ color: 'red', marginLeft: '3px' }}>{formData.PackingGSTAmount}</span>
                    </label>
                    <input
                        type="number"
                        name="PackingAmount"
                        value={formData.PackingAmount}
                        onChange={handleChange}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>TCS</label>
                    <input
                        type="number"
                        name="TCSAmount"
                        value={formData.TCSAmount}
                        onChange={handleChange}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Round Off</label>
                    <input
                        type="number"
                        name="RoundOff"
                        value={formData.RoundOff}
                        onChange={handleChange}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Total</label>
                    <input
                        type="number"
                        name="GrandTotal"
                        value={formData.GrandTotal}
                        onChange={handleChange}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                            color: "#0D47A1"
                        }}
                    />
                </div>

                {/* Cash */}
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Cash</label>
                    <input
                        type="number"
                        name="CashAmount"
                        placeholder="CashAmount"
                        value={formData.CashAmount}
                        onChange={handleChange}
                        min="0"
                        max={Math.max(
                            0,
                            parseFloat(formData.GrandTotal || 0) -
                            (parseFloat(formData.CardAmount || 0) +
                                parseFloat(formData.UPIAmount || 0))
                        )}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "15px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                        }}
                    />
                </div>

                {/* Card */}
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Card</label>
                    <input
                        type="number"
                        name="CardAmount"
                        placeholder="CardAmount"
                        value={formData.CardAmount}
                        onChange={handleChange}
                        min="0"
                        max={Math.max(
                            0,
                            parseFloat(formData.GrandTotal || 0) -
                            (parseFloat(formData.CashAmount || 0) +
                                parseFloat(formData.UPIAmount || 0))
                        )}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "15px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                        }}
                    />
                </div>

                {/* UPI */}
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>UPI</label>
                    <input
                        type="number"
                        name="UPIAmount"
                        placeholder="UPIAmount"
                        value={formData.UPIAmount}
                        onChange={handleChange}
                        min="0"
                        max={Math.max(
                            0,
                            parseFloat(formData.GrandTotal || 0) -
                            (parseFloat(formData.CashAmount || 0) +
                                parseFloat(formData.CardAmount || 0))
                        )}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "15px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Balance</label>
                    <input
                        value={formData.BalanceAmount}
                        type="text"
                        placeholder="BalanceAmount"
                        style={{
                            textAlign: 'right',
                            color: formData.BalanceAmount > 0 ? 'red' : 'inherit',// Sets color to red if BlanceAmount > 0
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                            //color: "#0D47A1"
                        }}
                        name='BalanceAmount'
                        readOnly
                        onChange={handleChange}
                    />
                </div>
                {/* </div> */}
            </div>

            {/* Amount Summary */}
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(6, 1fr)",
                    gap: "8px",
                    marginBottom: "12px",
                    fontSize: "12px"
                }}
            >
                <div>
                    Amount:{" "}
                    <span style={{ color: "#B71C1C", fontWeight: "bold" }}>
                        {formData.Amount}
                    </span>
                </div>
                <div>
                    Discount:{" "}
                    <span style={{ color: "#B71C1C", fontWeight: "bold" }}>
                        {formData.DiscountAmount}
                    </span>
                </div>
                <div>
                    Taxable:{" "}
                    <span style={{ color: "#B71C1C", fontWeight: "bold" }}>
                        {formData.TaxableAmount}
                    </span>
                </div>
                <div>
                    CGST: <span style={{ color: "#B71C1C", fontWeight: "bold" }}>{formData.CGSTAmount}</span>
                </div>
                <div>
                    SGST: <span style={{ color: "#B71C1C", fontWeight: "bold" }}>{formData.SGSTAmount}</span>
                </div>
                <div>
                    IGST: <span style={{ color: "#B71C1C", fontWeight: "bold" }}>{formData.IGSTAmount}</span>
                </div>
            </div>

            {/* Data Table */}
            <div
                style={{
                    maxHeight: "300px",
                    overflowY: "auto",
                    marginBottom: "12px",
                    border: "1px solid #999",
                    borderRadius: "4px",
                    backgroundColor: "#fff",
                }}
            >
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "13px",
                        fontFamily: "monospace",
                    }}
                >
                    <thead style={{ backgroundColor: "#1F2A38", color: "#FFFFFF" }}>
                        <tr>
                            {[
                                "SL.No",
                                'ITEM',
                                'S.QTY',
                                'R.QTY',
                                'RATE',
                                'AMOUNT',
                                'DIS %',
                                'DIS ₹',
                                'TAXABLE',
                                'GST ₹',
                                'TOTAL',

                            ].map((header, idx) => (
                                <th
                                    key={idx}
                                    style={{
                                        padding: "3px",
                                        //textAlign: idx > 1 & 9 ? "right" : "left",
                                        textAlign: idx > 1 ? "center" : "left",
                                        borderBottom: "1px solid #ccc",
                                        textTransform: 'uppercase',
                                        fontSize: '10px'
                                    }}                                >
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.map((item, index) => (
                            <tr
                                key={index}
                                style={{
                                    backgroundColor: index % 2 === 0 ? "#FDFDFD" : "#F5F7FA",
                                    borderBottom: "1px solid #ddd",
                                }}
                            >
                                {/* SL.No + Delete */}
                                <td style={{ padding: "4px 6px", textAlign: "center" }}>
                                    {index + 1}
                                    <Tooltip
                                        title="Delete Row"
                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    backgroundColor: "darkolivegreen",
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    fontSize: "0.8rem",
                                                },
                                            },
                                        }}
                                    >
                                        <DeleteIcon
                                            style={{
                                                color: "brown",
                                                cursor: "pointer",
                                                marginLeft: "8px",
                                                fontSize: "16px",
                                                verticalAlign: "middle",
                                            }}
                                            onClick={() => openConfirmDialog(index)}
                                        />
                                    </Tooltip>
                                </td>

                                {/* Item Name */}
                                <td
                                    style={{
                                        fontSize: "13px",
                                        //fontWeight: "bold",
                                        padding: "4px",
                                        minWidth: "200px",
                                    }}
                                >
                                    {item.ItemName}
                                </td>
                                {/* Saled Quantity */}
                                <td style={{ padding: "2px", textAlign: "right", width: "70px" }}>
                                    <input
                                        type="number"
                                        value={item.SaleQuantity}
                                        name="SaledQuantity"
                                        onChange={(e) => handleCalculation(e, index, "SaleQuantity")}
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            //backgroundColor: "#ECFAE5",
                                            //fontWeight: "bold",
                                            border: "1px solid #bbb",
                                            borderRadius: "3px",
                                            padding: "2px",
                                        }}
                                        disabled
                                    />
                                </td>
                                {/* Quantity */}
                                <td style={{ padding: "2px", textAlign: "right", width: "70px" }}>
                                    <input
                                        type="number"
                                        value={item.Quantity}
                                        //onChange={(e) => handleCalculation(e, index, 'Quantity')}
                                        className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                        min="0"
                                        aria-label={`ReturnQuantity for item ${item.Id}`}
                                        name="Quantity"
                                        onChange={(e) => {
                                            const newValue = parseInt(e.target.value, 10);
                                            if (newValue <= item.SaleQuantity) {
                                                handleCalculation(e, index, 'Quantity');
                                            }
                                        }}
                                        max={item.SaleQuantity}
                                        onClick={(e) => e.target.select()}
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            border: "1px solid #bbb",
                                            borderRadius: "3px",
                                            padding: "2px",
                                        }}
                                    />
                                </td>

                                {/* Rate */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        type="number"
                                        value={item.Rate || 0}
                                        name="Rate"
                                        onChange={(e) => handleCalculation(e, index, "Rate")}
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            //backgroundColor: "#F6D6D6",
                                            //fontWeight: "bold",
                                            border: "1px solid #bbb",
                                            borderRadius: "3px",
                                            padding: "2px",
                                        }}
                                    />
                                </td>

                                {/* Amount */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={item.Amount || 0}
                                        readOnly
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            border: "1px solid #ccc",
                                            //backgroundColor: "#fdfdfd",
                                            padding: "2px",
                                            borderRadius: "3px",
                                            //fontWeight: "bold",
                                        }}
                                    />
                                </td>

                                {/* Discount % */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        type="number"
                                        value={item.DiscountPercentage || 0}
                                        name="DiscountPercentage"
                                        onChange={(e) =>
                                            handleCalculation(e, index, "DiscountPercentage")
                                        }
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            //backgroundColor: "#F2EFE7",
                                            border: "1px solid #bbb",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            //fontWeight: "bold",
                                        }}
                                    />
                                </td>

                                {/* Discount Amount */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={item.DiscountAmount || 0}
                                        readOnly
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            border: "1px solid #ccc",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            //fontWeight: "bold",
                                        }}
                                    />
                                </td>

                                {/* Taxable */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={item.TaxableAmount || 0}
                                        readOnly
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            border: "1px solid #ccc",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            //fontWeight: "bold",
                                        }}
                                    />
                                </td>

                                {/* GST */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={
                                            parseFloat(item.CGSTAmount) +
                                            parseFloat(item.SGSTAmount) +
                                            parseFloat(item.IGSTAmount)
                                        }
                                        readOnly
                                        style={{
                                            width: "70%",
                                            textAlign: "right",
                                            border: "1px solid #ccc",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            // fontWeight: "bold",
                                        }}
                                    />
                                    <span
                                        style={{
                                            marginLeft: "4px",
                                            color: "darkmagenta",
                                            fontSize: "11px",
                                            //fontWeight: "bold",
                                        }}
                                    >
                                        {item.GSTRate ? parseFloat(item.GSTRate) : 0}%
                                    </span>
                                </td>

                                {/* Total */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={item.TotalAmount || 0}
                                        readOnly
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            //backgroundColor: "#DDE9EC",
                                            border: "1px solid #888",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            fontWeight: "bold",
                                            color: 'brown'
                                        }}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Extra Charges + Remarks */}
            {/* Top Section - Remarks & Bank */}
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: formData.UPIAmount > 0 || formData.CardAmount > 0
                        ? "3fr 1fr" // show both side by side
                        : "1fr",    // only Remarks
                    gap: "8px",
                    //marginBottom: "13px",
                    fontSize: "13px",
                    alignItems: "end",
                }}
            >
                {/* Remarks */}
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Remarks</label>
                    <textarea
                        name="Remarks"
                        value={formData.Remarks}
                        onChange={handleChange}
                        rows={1}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "13px",
                            width: "100%",
                            padding: "4px",
                            resize: "vertical",
                        }}
                    />
                </div>

                {/* Bank - conditional */}
                {(formData.UPIAmount > 0 || formData.CardAmount > 0) && (
                    <div>
                        <label style={{ fontSize: "11px", fontWeight: "600" }}>Bank</label>
                        <Select
                            value={selectedBank || { value: "", label: "Select Bank" }}
                            onChange={handleBankChange}
                            options={bankOptions}
                            placeholder="Select Bank"
                            isSearchable
                            menuPortalTarget={document.body}
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    minHeight: "29px",
                                    height: "29px",
                                    fontSize: "13px",
                                    width: "100%",
                                }),
                                valueContainer: (base) => ({
                                    ...base,
                                    height: "29px",
                                    padding: "0 6px",
                                }),
                                indicatorsContainer: (base) => ({ ...base, height: "29px" }),
                                menuPortal: (base) => ({ ...base, zIndex: 2000 }),
                                menu: (provided) => ({ ...provided, fontSize: "13px" }),
                            }}
                        />
                    </div>
                )}
            </div>
        </div >
    );
}
export default SaleReturnEdit;
